import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { StepType } from '../../models/step-type.model';
import { StepComponent } from '../step/step.component';

@Component({
  selector: 'app-as-step',
  templateUrl: './account-security-step.component.html',
  styleUrls: ['./account-security-step.component.scss']
})
export class AccountSecurityStepComponent extends StepComponent implements OnInit {
  constructor(translate: TranslateService) {
    super(translate);
  }

  ngOnInit() {
    this.setTitle('MyProfile_AS_AccountSecurity');
  }

  public modelChange() {
    this.stepModelChanged.emit({
      stepType: StepType.AccountSecurity,
      validState: this.isValidState()
    });
  }

  public qnaChanged() {
    this.modelChange();
  }

  public passwordChanged(): void {
    this.modelChange();
  }

  private isValidState(): boolean {
    return this.stepAccount.qna.answer !== undefined &&
      this.stepAccount.qna.answer.length &&
      (this.stepAccount.passwordState.value !== undefined &&
        this.stepAccount.passwordState.value.length &&
        this.stepAccount.passwordState.isValid !== undefined &&
        this.stepAccount.passwordState.isValid)
      ? true
      : false;
  }
}
